'use strict';

var format = require('date-fns/format');
var parsers = require('../parsers.cjs');
var getLocaleData = require('../utils/getLocaleData.cjs');
var getFormatStringForSingleTimePreset = require('./formatStrings/getFormatStringForSingleTimePreset.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var format__default = /*#__PURE__*/_interopDefault(format);

const formatISODatePart = (params) => {
  const { presetName, isoDatePart, locale } = params;
  const date = parsers.isoDatePartToDate(isoDatePart);
  return format__default(date, getFormatStringForSingleTimePreset.getFormatStringForSingleTimePreset(presetName, locale), {
    locale: getLocaleData(locale)
  });
};

module.exports = formatISODatePart;
//# sourceMappingURL=formatISODatePart.cjs.map
